var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-5",
    cx: 251.02,
    cy: 347.46,
    rx: 238.64,
    ry: 144.36,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-5",
    d: "M294,223.57c-12.08,7-12.08,18.29,0,25.27s31.68,7,43.77,0,12.09-18.29,0-25.27S306.11,216.59,294,223.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M102.5,356.69,30.16,315.31a1,1,0,0,1,0-1.81l197.51-114a3.47,3.47,0,0,1,3.14,0l72.34,41.38a1,1,0,0,1,0,1.81l-197.51,114A3.47,3.47,0,0,1,102.5,356.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-5",
    cx: 159.36,
    cy: 409.68,
    rx: 17.7,
    ry: 10.22,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.27 362.05 284.7 470.81 188.96 415.84 377.53 307.08 473.27 362.05",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.38,291.79s.45-14.83-3.16-25.08-10.66-17.65-17.85-20-14.68,3-7.94,9.51S39,270.73,41.31,289.54Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.38,291.79s.45-14.83-3.16-25.08-10.66-17.65-17.85-20-14.68,3-7.94,9.51S39,270.73,41.31,289.54Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M45.47,285.27h.08a.41.41,0,0,0,.34-.46C42.65,264,29.81,252.56,23.48,249.44a.4.4,0,0,0-.36.72c6.21,3.05,18.78,14.26,22,34.77A.39.39,0,0,0,45.47,285.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.92,272.22c.08,1.58,1.29,2.85,2.46,3.93s2.43,2.24,2.68,3.8c.52,3.15-3.33,5.85-2.68,9s4.55,4.1,7.09,5.16a6.83,6.83,0,0,1,3.92,3.39,10.65,10.65,0,0,1,.27,4.4c-.1,2.7.37,6.71,2.59,8.56,2.57,2.15,6.93,3.33,10,1.86,5.76-2.76,11.61-7.15,12.16-14.05a13.56,13.56,0,0,0-4.29-10.93c-1.14-1.05-2.45-1.89-3.53-3-2.21-2.25-1.84-5.33-2.52-8.22-.61-2.58-3.11-3.83-5.55-4.32s-4.88,0-7.08-1-4-2.32-6.31-3a8.3,8.3,0,0,0-7.21.85A4.38,4.38,0,0,0,15.92,272.22Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.66,304.88h0a.35.35,0,0,0,.39-.32c2.32-22.3-17.9-33.35-23-34.89a.35.35,0,0,0-.44.24.36.36,0,0,0,.23.45c5,1.5,24.8,12.31,22.54,34.13A.35.35,0,0,0,43.66,304.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.87,285.59a.31.31,0,0,0,.21,0A18.93,18.93,0,0,1,40.15,287a.36.36,0,0,0,.49-.13.36.36,0,0,0-.14-.49,19.68,19.68,0,0,0-16.71-1.46.35.35,0,0,0,.08.67Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--table--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--table--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.12,199.49a.86.86,0,0,1,.5-.7,2.69,2.69,0,0,1,2.41,0,.86.86,0,0,1,.5.7l-6.07,35.82h0a.61.61,0,0,1-.35.48,1.89,1.89,0,0,1-1.7,0,.61.61,0,0,1-.35-.48h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.91,199.49a.84.84,0,0,0-.5-.7,2.69,2.69,0,0,0-2.41,0,.86.86,0,0,0-.5.7l6.07,35.82h0a.63.63,0,0,0,.35.48,1.91,1.91,0,0,0,1.71,0,.63.63,0,0,0,.35-.48h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.43,202.2a.85.85,0,0,0-.5-.69,2.63,2.63,0,0,0-2.41,0,.85.85,0,0,0-.5.69l.5,42.61h0a.6.6,0,0,0,.35.48,1.85,1.85,0,0,0,1.71,0,.6.6,0,0,0,.35-.48h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.26,187.69h0c0-4.51-3-9-8.92-12.47-11.93-6.88-31.26-6.88-43.19,0-6,3.45-8.92,8-8.92,12.47h0v2.42h0c.07,4.46,3.06,8.9,8.94,12.29,11.93,6.89,31.26,6.89,43.19,0,5.89-3.39,8.87-7.83,8.94-12.29h0Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.13,175.22c-11.93,6.89-11.93,18.05,0,24.94s31.26,6.88,43.19,0,11.93-18,0-24.94S306.06,168.34,294.13,175.22Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.13,175.22c-11.93,6.89-11.93,18.05,0,24.94s31.26,6.88,43.19,0,11.93-18,0-24.94S306.06,168.34,294.13,175.22Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.05
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.41,181.86c3.81,2.2,3.81,5.76,0,8a15.25,15.25,0,0,1-13.77,0c-3.81-2.2-3.81-5.76,0-8A15.25,15.25,0,0,1,322.41,181.86Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M309.47,186.33c-3.32-3.38-5.26-11.82-2-14.5h16.44c3.23,2.68,1.29,11.12-2,14.5l-.09.09-.12.11-.3.27-.08.06-.25.19a4.94,4.94,0,0,1-.42.27,10.87,10.87,0,0,1-9.87,0h0c-.15-.08-.29-.17-.44-.27l-.23-.18-.1-.07-.28-.26-.14-.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.45,170.75c3.76,2.16,3.76,5.68,0,7.84a15,15,0,0,1-13.58,0c-3.75-2.16-3.75-5.68,0-7.84A15,15,0,0,1,322.45,170.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.79,172.28c2.29,1.32,2.29,3.46,0,4.78a9.17,9.17,0,0,1-8.26,0c-2.28-1.32-2.28-3.46,0-4.78A9.17,9.17,0,0,1,319.79,172.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.53,174.55a9.11,9.11,0,0,1,8.26,0,3.83,3.83,0,0,1,1.37,1.25,3.76,3.76,0,0,1-1.37,1.26,9.17,9.17,0,0,1-8.26,0,3.76,3.76,0,0,1-1.37-1.26A3.83,3.83,0,0,1,311.53,174.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.29,175.8a18.66,18.66,0,0,0,3-4c1.38-2.44,1.64-5.71.92-6.12s-3.62,2.86-3.62,2.86a17.67,17.67,0,0,0,.31-4.17c-.12-2.17-.65-4.15-1.28-4.54s-2,2.34-2.61,4.33-.95,3.62-.95,3.62a30.92,30.92,0,0,0-1.07-4.57c-.73-2.07-1.39-2.53-1.9-2.33s-.84,1.17-1,3.91a26.62,26.62,0,0,0,.12,3.94s-1-1.13-2.16-2.22-1.78-1.37-2.14-1.14-.46,2.1,1.48,5.6a19.41,19.41,0,0,0,3.65,4.8S314.72,177.53,319.29,175.8Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.29,175.8a18.66,18.66,0,0,0,3-4c1.38-2.44,1.64-5.71.92-6.12s-3.62,2.86-3.62,2.86a17.67,17.67,0,0,0,.31-4.17c-.12-2.17-.65-4.15-1.28-4.54s-2,2.34-2.61,4.33-.95,3.62-.95,3.62a30.92,30.92,0,0,0-1.07-4.57c-.73-2.07-1.39-2.53-1.9-2.33s-.84,1.17-1,3.91a26.62,26.62,0,0,0,.12,3.94s-1-1.13-2.16-2.22-1.78-1.37-2.14-1.14-.46,2.1,1.48,5.6a19.41,19.41,0,0,0,3.65,4.8S314.72,177.53,319.29,175.8Z",
    style: {
      opacity: 0.30000000000000004
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--WiFi--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--wifi--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.45,126.91a2.24,2.24,0,0,0-2.33-.12c-2.28,1-4.45,4.44-4.84,7.74-.23,2,.22,3.41,1.1,4.06l2.29,1.7a2.25,2.25,0,0,0,2.32.11c2.28-1,4.45-4.44,4.84-7.74.23-1.94-.21-3.39-1.08-4C319.36,128.32,317.84,127.2,317.45,126.91Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.45,126.91a2.24,2.24,0,0,0-2.33-.12c-2.28,1-4.45,4.44-4.84,7.74-.23,2,.22,3.41,1.1,4.06l2.29,1.7a2.25,2.25,0,0,0,2.32.11c2.28-1,4.45-4.44,4.84-7.74.23-1.94-.21-3.39-1.08-4C319.36,128.32,317.84,127.2,317.45,126.91Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.46,115.59c-1.89-1.39-4.4-1.62-7.31-.37-5,2.13-8.92,7.11-11.81,13.95-.59,1.39-.54,2.78.11,3.3h0c.76.61,2.07,1.49,2.71,2h0c.81.65,2.24-.33,3-2.08,2-4.85,4.57-8.1,8.07-9.6a5.75,5.75,0,0,1,3.63-.44,7.52,7.52,0,0,1,.89,2,1.23,1.23,0,0,0,.42.67l2.73,2c.58.42,1.54,0,2.34-1.07h0a4.82,4.82,0,0,0,.94-3.74,8.72,8.72,0,0,0-2.94-4.6Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.46,115.59c-1.89-1.39-4.4-1.62-7.31-.37-5,2.13-8.92,7.11-11.81,13.95-.59,1.39-.54,2.78.11,3.3h0c.76.61,2.07,1.49,2.71,2h0c.81.65,2.24-.33,3-2.08,2-4.85,4.57-8.1,8.07-9.6a5.75,5.75,0,0,1,3.63-.44,7.52,7.52,0,0,1,.89,2,1.23,1.23,0,0,0,.42.67l2.73,2c.58.42,1.54,0,2.34-1.07h0a4.82,4.82,0,0,0,.94-3.74,8.72,8.72,0,0,0-2.94-4.6Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.22,112.18a13,13,0,0,0-4.17-5.74c-.47-.35-2.31-1.72-2.77-2-3-2.26-7.08-2.63-11.75-.63-7.38,3.17-13.35,9.4-18.07,19.37-.69,1.47-.73,3,0,3.59h0c.79.64,2,1.44,2.71,2h0c.78.64,2.13-.27,2.91-1.93,3.83-8.16,8.49-12.86,14.53-15.46,3.12-1.33,5.89-1.37,8.16-.33a11.71,11.71,0,0,1,2.15,3.57,1.25,1.25,0,0,0,.4.55l2.72,2c.59.44,1.53.07,2.34-1A4.65,4.65,0,0,0,331.22,112.18Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.22,112.18a13,13,0,0,0-4.17-5.74c-.47-.35-2.31-1.72-2.77-2-3-2.26-7.08-2.63-11.75-.63-7.38,3.17-13.35,9.4-18.07,19.37-.69,1.47-.73,3,0,3.59h0c.79.64,2,1.44,2.71,2h0c.78.64,2.13-.27,2.91-1.93,3.83-8.16,8.49-12.86,14.53-15.46,3.12-1.33,5.89-1.37,8.16-.33a11.71,11.71,0,0,1,2.15,3.57,1.25,1.25,0,0,0,.4.55l2.72,2c.59.44,1.53.07,2.34-1A4.65,4.65,0,0,0,331.22,112.18Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.83,132.66c-.39,3.3-2.56,6.76-4.84,7.74s-3.82-.89-3.43-4.18,2.56-6.76,4.84-7.74S321.22,129.37,320.83,132.66Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.87,117.23c-5,2.14-8.93,7.12-11.81,14-.59,1.39-.54,2.78.1,3.3h0c.81.65,2.24-.33,3-2.08,2-4.85,4.57-8.1,8.07-9.6s6.21,0,7.24,3.55c.37,1.29,1.71,1.08,2.77-.38h0a4.82,4.82,0,0,0,.94-3.74C325.68,117.26,321.84,115.1,316.87,117.23Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.25,105.77c-7.39,3.18-13.36,9.4-18.07,19.38-.7,1.46-.73,3,0,3.58h0c.78.64,2.13-.27,2.91-1.93,3.83-8.16,8.49-12.86,14.53-15.46s10.82-.32,13,5.25c.45,1.14,1.71.93,2.74-.49h0a4.65,4.65,0,0,0,.86-3.93C328.51,105.39,322.66,102.6,315.25,105.77Z",
    style: {
      fill: "#00FF00"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Case--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.05,205.77l4.13-2.38L256.67,85.73c.75-3.93-1.44-5.5-4.91-3.5L71.18,186.36a18,18,0,0,0-7.63,10.73L41.49,312.51A3.22,3.22,0,0,0,43,315.9l50.61,29.29,188.88-109Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.81,198.54l-22,115.2,193-110.69L258.94,87.17c.75-3.92-1.45-5.49-4.91-3.49L73.45,187.81A18,18,0,0,0,65.81,198.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.66 204.69 43.77 313.74 95.09 343.38 283.97 234.33 232.66 204.69",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.09,85.93l-182,104.88c-4,2.3-5.24,6-4.53,10.94L90.32,339.6c.71,4.91,4.62,7.79,8.61,5.48L279.3,241c4-2.3,6.65-8.15,5.95-13.07L265.59,90.66C264.89,85.75,261.08,83.63,257.09,85.93Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tablet--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.36,89.14a5.63,5.63,0,0,0-4.91.61L84.08,193.85a12.08,12.08,0,0,0-4.6,5.28l-5.82-2.47c1.28-2.79,3.51-3.81,5.42-4.92L259.44,87.64a5.52,5.52,0,0,1,5.1-.52h0Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.36,89.14a5.63,5.63,0,0,0-4.91.61L84.08,193.85a12.08,12.08,0,0,0-4.6,5.28l-5.82-2.47c1.28-2.79,3.51-3.81,5.42-4.92L259.44,87.64a5.52,5.52,0,0,1,5.1-.52h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.17,346.6h0c-1.79-.73-3.11-2.59-3.5-5.29L73.13,204.8c-.44-3.07-.59-5.82.53-8.14l5.82,2.47c-.15.32-.29.65-.43,1s-.2.54-.29.81a.42.42,0,0,0,0,.12c-.11.31-.2.63-.28.94s-.16.66-.21,1a6.42,6.42,0,0,0-.1.75,11.36,11.36,0,0,0,0,3.19L97.79,344.17c.39,2.73,1.74,4.61,3.55,5.33Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34,349.5l-.29-.12-4.88-2.77v0c-1.79-.73-3.11-2.58-3.5-5.29L73.13,204.81c-.45-3.08-.59-5.83.52-8.15l5,2.1a12.28,12.28,0,0,0-.67,6.82l.2,1.34L97.79,344.19a4.54,4.54,0,0,0,.09.51,2.14,2.14,0,0,0,.06.27,2.22,2.22,0,0,0,.09.37c0,.13.06.25.1.37l.12.35a3,3,0,0,0,.17.41c.06.14.12.27.19.4s.13.25.2.37a6,6,0,0,0,.72,1l.26.27.29.26A4.77,4.77,0,0,0,101.34,349.5Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.45,89.76l-182,104.87c-4,2.31-5.23,6-4.53,11l19.85,138.6c.7,4.92,4.51,7,8.5,4.73L286.65,244.82c4-2.3,6.66-8.16,6-13.07L273,94.49C272.25,89.57,268.44,87.46,264.45,89.76Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.45,89.76l-182,104.87c-4,2.31-5.23,6-4.53,11l19.85,138.6c.7,4.92,4.51,7,8.5,4.73L286.65,244.82c4-2.3,6.66-8.16,6-13.07L273,94.49C272.25,89.57,268.44,87.46,264.45,89.76Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.05,244l-161,92.9c-2.07,1.2-4,.1-4.41-2.45L91.6,201.42a7.21,7.21,0,0,1,3.08-6.78l161-92.9c2.07-1.2,4-.1,4.4,2.45l19.05,133.05A7.17,7.17,0,0,1,276.05,244Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6,201.42l19.05,133.05.06.3,161-92.91a7.15,7.15,0,0,0,3.08-6.77l-19.1-133.35-161,92.9A7.21,7.21,0,0,0,91.6,201.42Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6,201.42l19.05,133.05.06.3,161-92.91a7.15,7.15,0,0,0,3.08-6.77l-19.1-133.35-161,92.9A7.21,7.21,0,0,0,91.6,201.42Z",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.17,275.84a3.6,3.6,0,0,1-1.55,3.4c-1,.6-2,.05-2.22-1.23A3.62,3.62,0,0,1,95,274.6C96,274,97,274.55,97.17,275.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,253.63h0a2.82,2.82,0,0,0-1.21,2.65l1.7,11.85c.14,1,.91,1.42,1.72,1h0a2.82,2.82,0,0,0,1.21-2.65l-1.7-11.85C93.53,253.6,92.76,253.17,92,253.63Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--personal-trainer--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.82,268.31l-22.23,12.83-5.19,3-34.94,20.15c2.48-22,6.58-52.85,11-62.72l49,1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.47,254.6C214.2,265.61,204.2,271,204.2,271l-.61,10.19-5.19,3,1.46-15.32S212.61,263.68,217.47,254.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.53,175.29c3.86-2.43,11.22-4.36,17.49-2.21,9.16-5.25,17.21-4.22,24.93-3.05,1.91.29,8.24-.63,9.44.46.91.83,1.17,1.8,1.61,3.73l-3.85,10.25c-6.69,1.33-10.55,3-20.13,4.48-7.55,1.19-12.38,1.93-13.21,5.5A59.19,59.19,0,0,1,206.53,175.29Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.26,180.72c1.27-1.59,1.31-3.54,1.16-6.09-.23-4.09-.93-12.13-1.54-15.66-1-5.63-1.35-9.16-2.52-12.76-1.51-4.66-1-7.56-3.1-10.72S245,130,242.77,134.65c-1.25,2.67,3.33,4,3.46,6,0,0-3.58,2.8-1,3.76,2,.76,3.94,1.08,4.54,7.41.53,5.59-1.34,11.82-1.34,20.27,0,3.48,1.75,13.72,1.75,13.72C254.48,184.65,260.42,184.28,263.26,180.72Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.54,143.59c.3,1.1,5.35,2,6.48,1.78a1.76,1.76,0,0,0,1.39-1.09l3.47,1.06.13-2.89-11.24-.54A4.93,4.93,0,0,0,245.54,143.59Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.15,174s-.69-3.66-7.61-6.14c0,.67-.11,1.45-.11,2.07A15.59,15.59,0,0,1,256.15,174Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Dumbbell--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.28,132.15a0,0,0,0,0,0,0,6,6,0,0,0-10.05-2.67l0,0-.11.13a.86.86,0,0,0-.13.14,12.08,12.08,0,0,0-2.6,10.24s0,0,0,0v0c0,.18.1.35.16.52h0a6,6,0,0,0,7.16,3.73,6.4,6.4,0,0,0,1.24-.49,5.63,5.63,0,0,0,1.53-1.1,12.05,12.05,0,0,0,2.84-10.52A.42.42,0,0,1,243.28,132.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.23,130.57a12.05,12.05,0,0,0-2.84,10.52c.89,3.35,3.61,4.09,6.07,1.64a12.05,12.05,0,0,0,2.84-10.52C242.41,128.86,239.69,128.12,237.23,130.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.57,139.59h-.05L240,133.87h0a1.43,1.43,0,0,0-1.44.5,4.62,4.62,0,0,0-1.1,4,1.47,1.47,0,0,0,1,1.15L259,145.28h0a1.45,1.45,0,0,0,1.42-.51,4.62,4.62,0,0,0,1.09-4A1.49,1.49,0,0,0,260.57,139.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.06,144.14c.34,1.29,1.38,1.57,2.33.63a4.62,4.62,0,0,0,1.09-4,1.27,1.27,0,0,0-2.33-.63A4.62,4.62,0,0,0,258.06,144.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.64,136.17c-.95-2.76-.63-3.33-2.92-3.83s-2.31-2.4-4.59-2.13-4,1-5,.73-3.05.79-4,2.32-.93,3.79-.8,5.34,1.72,3.47,5,4.31,6.61,1.56,7.3,0c.54-1.24.05-2.3.21-3a2.87,2.87,0,0,1,1.58-1.94l1.61.44Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.7,138.88a0,0,0,0,1,0,0,6,6,0,0,0-10.05-2.68l0,0-.12.12-.13.14a12.14,12.14,0,0,0-2.59,10.25.08.08,0,0,0,0,0v0c0,.18.11.35.17.52h0a6,6,0,0,0,7.16,3.72,6.4,6.4,0,0,0,2.76-1.58,12,12,0,0,0,2.85-10.52A.14.14,0,0,1,267.7,138.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.64,137.3a12.05,12.05,0,0,0-2.84,10.52c.9,3.35,3.61,4.09,6.07,1.64a12.07,12.07,0,0,0,2.85-10.52C266.82,135.58,264.11,134.85,261.64,137.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.6,150.75c-.51-1.66-3.71-3.76-5.69-4.83a5.88,5.88,0,0,1-3.24-3.76,2,2,0,0,1,.35-1.74,7.57,7.57,0,0,1,1.52-1l2.16-1.14c.82-.44,1.6-1,2.39-1.5a2.69,2.69,0,0,1,.61-.31.83.83,0,0,1,.67.08c.78.55.68,2.06.36,2.82a6.67,6.67,0,0,1-1.49,1.91A4.24,4.24,0,0,0,246,143c-.12.63.67,1.11,1.14,1.32a13.52,13.52,0,0,0,2.7.93C251.05,145.49,249.24,149.58,249.6,150.75Z",
    style: {
      fill: "#ffa8a7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M221,190.68c-1.37-7.86-8.26-14.77-18.26-15.83l-13.45-.23s-3.47.58-9.47,1.84-9.1,4.09-9.63,8.87c-.35,3.21-.22,5,.86,10.35l1.32,9.17s4.64,12.76,5,17.65a41.31,41.31,0,0,1-2.93,19.07c17.7,7.78,34.2,10.24,47.91.36C224.41,230,224.79,212.14,221,190.68Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.62,202.82C223,184,206.53,175.29,206.53,175.29L195.37,173l-15.74,3.5s3.93,19.54-7.22,28.34c0,0,.83,3.48,2.74,10.66s3.33,16.79-2.49,28.2c0,0,4.9,4.84,23.49,6.15s27.35-7.28,27.35-7.28S226.2,221.69,224.62,202.82Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.67,249.55c1-1.6,2-3.75,2-5.15-.1-2.46-9.21-3.52-10.89-4.49s-1.08-8.91-1.7-15.31-4.62-17-6.6-22.1l.44-1.35a17.35,17.35,0,0,1-3.48,3.7s.83,3.48,2.74,10.66,3.33,16.79-2.49,28.2C172.66,243.71,177,247.93,192.67,249.55Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.63,176.51s-7.67-2-12.73,1c-4.16,2.46-6.42,5.43-8.37,11.37a49.89,49.89,0,0,0-8.77,8.88c-4.6,6.29-8,13.63-10.57,17.66-1.4,2.18-3.26,4.27-2.78,7.41.19,1.22,1,1.92,2.41,3.27l14.1-3.93c4.14-4.52,13.33-11,19-18.33l.49,1a17.84,17.84,0,0,0,8.37-14.07C181.45,179.16,179.63,176.51,179.63,176.51Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.26,224.48c1.56,1.59,4.09,5.24,9,9.44,3.73,3.2,11.92,8,15,9.77,4.24,2.44,5.85,3.64,9.12,5.59,2.47,1.46,7.92,4.28,13.11,4.31,3,0,6.77-1.91,9.09-6.43,1.19-2.31-2.55-3.79-7.58-4.6-6.28-1-7.5-2.36-9.05-3.18-1-.56-1-1.25-.61-2.37a14,14,0,0,0,.63-2.45c-.24-.17-1.45,0-2.84,1.1-1.68,1.35-3.09,1.68-7.08-2.41-4.13-4.24-5.81-8.41-11.21-13S137.26,224.48,137.26,224.48Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.35,200.8c.1-1.52.08-2.25.08-2.25a58.67,58.67,0,0,1-3.51,5.26l.49,1a15.3,15.3,0,0,0,3-2.35A7.74,7.74,0,0,1,175.35,200.8Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.82,220.23a10.52,10.52,0,0,0-8.22-.74s3.43-3.43,10.06-.93Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.53,134.31a6.2,6.2,0,0,0-4.29,4.29c-.75,2.47-.32,7.14,1.23,13.26a50.45,50.45,0,0,0,4.37,11.62,4.67,4.67,0,0,0,2.73,2.15l-.22-7.26-.3-5.07s3.23-4.46,3.56-8.1c.43-4.68-.57-6.59-.57-6.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.86,135.93l-5.4-1.11a3,3,0,0,1,3.35-2.37A2.84,2.84,0,0,1,184.86,135.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,134.54l-4-3.73a2.92,2.92,0,0,1,4.08-.3A2.82,2.82,0,0,1,185,134.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.86,142.93A11.82,11.82,0,1,0,207.57,131,11.82,11.82,0,0,0,195.86,142.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.24,152.49c-1.22,1.07-2.23-1.67-3.26-2.73s-4.4-2.49-6,1,1.52,8.6,4.1,9.6a3.67,3.67,0,0,0,3.71-.42l.1,15.41c1.77,3.45,8.75,7.91,16.71,6.54,3.41-.58,1.82-4.74,0-7.07l-.07-5.68a29.17,29.17,0,0,0,6.12.26c3.34-.55,5.06-3.08,6-6.7,1.57-5.82,2.16-15.58-.14-26.84-3.75-2.87-16.71-2.31-24.52,2.71C191.68,148.6,189.45,151.43,188.24,152.49Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.37,127.9a.6.6,0,0,0-.48-.37.83.83,0,0,0-.46.2,21.28,21.28,0,0,1-3,2,10.61,10.61,0,0,0,0-4c-.15-.82-.4-2.73-1.42-2.92-.6-.12-1.13.39-1.58.81-4.05,3.84-9.39,2.11-14.3,2.3-4.11.15-9.06,1.86-10.89,5.86-.84,1.84-1,3.76.71,5a11.69,11.69,0,0,0,5,1.84c8.2,1.37,20,4.67,26-3a6.06,6.06,0,0,0,1.24-4,8.32,8.32,0,0,0-.84-3.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.54,169.18s-7.46-1.43-10.08-2.79c-1.75-.91-4.1-2.4-4.53-3.42a6.54,6.54,0,0,0,2.69,4.64c4,3,11.95,4,11.95,4Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.5,149.66a1.52,1.52,0,0,1-1.47,1.56,1.54,1.54,0,0,1-1.51-1.55,1.49,1.49,0,1,1,3,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.67,145.11l-3.32,1.51a1.92,1.92,0,0,1,.94-2.48A1.78,1.78,0,0,1,200.67,145.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.7,159.23l6,2.18a3.13,3.13,0,0,1-4,2A3.33,3.33,0,0,1,201.7,159.23Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.65,163.42a3,3,0,0,0,1.65.11,2.88,2.88,0,0,0-2.9-2.75,3,3,0,0,0-.8.13A3.23,3.23,0,0,0,203.65,163.42Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.08,146.1l-3.46-1.25a1.78,1.78,0,0,1,2.3-1.14A1.94,1.94,0,0,1,215.08,146.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.31,149.22a1.49,1.49,0,1,1-1.51-1.54A1.53,1.53,0,0,1,214.31,149.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.13 147.56 207.05 157.01 212.05 155.31 206.13 147.56",
    style: {
      fill: "#f28f8f"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mat--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--mat--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "473.27 354.05 284.7 462.81 188.96 407.84 377.53 299.08 473.27 354.05",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.27 354.05 284.7 462.81 188.96 407.84 377.53 299.08 473.27 354.05",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.27 354.05 473.27 356.72 284.7 465.48 284.7 462.81 473.27 354.05",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.27 354.05 473.27 356.72 284.7 465.48 284.7 462.81 473.27 354.05",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.7 462.81 188.96 407.84 188.96 410.51 284.7 465.48 284.7 462.81",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.7 462.81 188.96 407.84 188.96 410.51 284.7 465.48 284.7 462.81",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--dumbbell--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--dumbbell--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M297.3,439.49l-2.13-1.23c-1.45-.84-1.45-2.19,0-3l4.76-2.75-14.86-8.59-4.76,2.75a5.85,5.85,0,0,1-5.25,0l-2.13-1.24c-1.45-.83-1.45-2.19,0-3L287.37,414a5.76,5.76,0,0,1,5.24,0l2.14,1.23c1.45.84,1.45,2.19,0,3l-5.26,3,14.86,8.59,5.26-3a5.82,5.82,0,0,1,5.24,0l2.14,1.24c1.45.83,1.45,2.19,0,3l-14.44,8.33A5.78,5.78,0,0,1,297.3,439.49Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M290,410.36s0,0,0-.05a7.48,7.48,0,0,0-11.28-6.44l-.05,0-.18.12a1.37,1.37,0,0,0-.2.13,15.09,15.09,0,0,0-6.42,11.53v.08c0,.23,0,.46,0,.68v0a7.45,7.45,0,0,0,9.09,6.6,6.86,6.86,0,0,0,2.2-.84,15,15,0,0,0,6.8-11.77S290,410.38,290,410.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.17,406.51a15,15,0,0,0-6.8,11.77c0,4.34,3.05,6.1,6.8,3.93a15,15,0,0,0,6.8-11.77C290,406.1,286.92,404.34,283.17,406.51Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.85,421.19h0l-.05,0L286.32,411h0a2.13,2.13,0,0,0-2.27.17,6.94,6.94,0,0,0-3.14,5.43,2.18,2.18,0,0,0,1,2l17.48,10.13h0a2.17,2.17,0,0,0,2.25-.19,6.93,6.93,0,0,0,3.13-5.43A2.24,2.24,0,0,0,303.85,421.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.46,426.81c0,2,1.4,2.81,3.13,1.81a6.93,6.93,0,0,0,3.13-5.43c0-2-1.4-2.81-3.13-1.81A6.93,6.93,0,0,0,298.46,426.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.62,423.44v0a7.48,7.48,0,0,0-7.48-7.49,7.4,7.4,0,0,0-3.79,1l-.05,0-.18.11-.21.13a15.1,15.1,0,0,0-6.41,11.53v.09c0,.22,0,.45,0,.68h0a7.46,7.46,0,0,0,9.1,6.6,6.64,6.64,0,0,0,2.2-.84,15,15,0,0,0,6.8-11.77S312.62,423.47,312.62,423.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.83,419.59a15,15,0,0,0-6.8,11.78c0,4.33,3,6.09,6.8,3.92a15,15,0,0,0,6.8-11.77C312.63,419.18,309.58,417.43,305.83,419.59Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Water--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--water--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.82,387.84a28.92,28.92,0,0,0-2.07-5.34c-.09-.2-.19-.39-.28-.59a10.94,10.94,0,0,1,.14-10.32c.07-.11.13-.22.19-.33a11.82,11.82,0,0,0,1.6-6.08,7.2,7.2,0,0,0-3.47-5.75,12.6,12.6,0,0,0-1.61-.78,2.75,2.75,0,0,1-1.75-2.55V353l-10.07,0v3.15a2.77,2.77,0,0,1-1.77,2.54,11,11,0,0,0-1.62.77,7.18,7.18,0,0,0-3.51,5.72,11.74,11.74,0,0,0,1.55,6.09l.17.31a11,11,0,0,1,.09,10.35c-.1.19-.2.38-.29.58a28,28,0,0,0-2.11,5.33,24.74,24.74,0,0,0-.49,5.42l-.06,14.66c0,1.9,1.24,3.81,3.74,5.26a17.59,17.59,0,0,0,7.28,2.13,22.12,22.12,0,0,0,3.64,0,17.52,17.52,0,0,0,7.25-2.07c2.52-1.43,3.78-3.33,3.79-5.23l0-10.6c0-1.32.06-2.7.06-4.08A24.72,24.72,0,0,0,171.82,387.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.61,371.59c.07-.11.13-.22.19-.33a11.66,11.66,0,0,0,1.56-5.15,9.39,9.39,0,0,1-1,2.09,20,20,0,0,1-4.54,4.73c-1.73,1.41-3.65,3-3.86,5.23s1.31,4.1,3,5.4,3.74,2.21,5.28,3.71a12.8,12.8,0,0,1,1.76,2.19c-.07-.55-.15-1.09-.26-1.62a28.92,28.92,0,0,0-2.07-5.34c-.09-.2-.19-.39-.28-.59A10.94,10.94,0,0,1,169.61,371.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.81,356.43v1.69a3.41,3.41,0,0,0,2,2.81,10.72,10.72,0,0,0,9.68,0,4.59,4.59,0,0,0,1.51-1.3,2.58,2.58,0,0,0,.5-1.48v-1.72a1.75,1.75,0,0,0-.05-.46,3.66,3.66,0,0,0-1.94-2.35l-.1-.05a10.7,10.7,0,0,0-9.58,0,3.66,3.66,0,0,0-2,2.32A2,2,0,0,0,152.81,356.43Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.81,356.43v1.69a3.41,3.41,0,0,0,2,2.81,10.72,10.72,0,0,0,9.68,0,4.59,4.59,0,0,0,1.51-1.3,2.58,2.58,0,0,0,.5-1.48v-1.72a1.75,1.75,0,0,0-.05-.46,3.66,3.66,0,0,0-1.94-2.35l-.1-.05a10.7,10.7,0,0,0-9.58,0,3.66,3.66,0,0,0-2,2.32A2,2,0,0,0,152.81,356.43Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.48,359.25c2.67-1.53,2.68-4,0-5.59a10.69,10.69,0,0,0-9.68,0c-2.68,1.53-2.69,4,0,5.58A10.69,10.69,0,0,0,164.48,359.25Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.81,354.45v1a2,2,0,0,0,.05.48,3.7,3.7,0,0,0,1.94,2.34,9.58,9.58,0,0,0,4.28,1.15,10.1,10.1,0,0,0,5.4-1.12A4.58,4.58,0,0,0,166,357a2.67,2.67,0,0,0,.45-1,1.83,1.83,0,0,0,.05-.47v-1.05a3.39,3.39,0,0,0-2-2.8c-.12-.07-.24-.14-.37-.2a10.74,10.74,0,0,0-9.31.16A3.41,3.41,0,0,0,152.81,354.45Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.81,354.45v1a2,2,0,0,0,.05.48,3.7,3.7,0,0,0,1.94,2.34,9.58,9.58,0,0,0,4.28,1.15,10.1,10.1,0,0,0,5.4-1.12A4.58,4.58,0,0,0,166,357a2.67,2.67,0,0,0,.45-1,1.83,1.83,0,0,0,.05-.47v-1.05a3.39,3.39,0,0,0-2-2.8c-.12-.07-.24-.14-.37-.2a10.74,10.74,0,0,0-9.31.16A3.41,3.41,0,0,0,152.81,354.45Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.81,354.42c0,2.17,3.05,3.94,6.83,4s6.85-1.74,6.86-3.91-3.05-3.94-6.83-4S152.82,352.25,152.81,354.42Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.3,350.38v3.55a.86.86,0,0,0,0,.16,1.29,1.29,0,0,0,.68.81,3.22,3.22,0,0,0,1.48.4,3.39,3.39,0,0,0,1.87-.39,1.46,1.46,0,0,0,.52-.45.85.85,0,0,0,.16-.35.88.88,0,0,0,0-.16V350.4a1.19,1.19,0,0,0-.69-1l-.12-.06a3.73,3.73,0,0,0-3.23.05A1.18,1.18,0,0,0,157.3,350.38Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.3,350.38v3.55a.86.86,0,0,0,0,.16,1.29,1.29,0,0,0,.68.81,3.22,3.22,0,0,0,1.48.4,3.39,3.39,0,0,0,1.87-.39,1.46,1.46,0,0,0,.52-.45.85.85,0,0,0,.16-.35.88.88,0,0,0,0-.16V350.4a1.19,1.19,0,0,0-.69-1l-.12-.06a3.73,3.73,0,0,0-3.23.05A1.18,1.18,0,0,0,157.3,350.38Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.3,350.37c0,.75,1.06,1.37,2.37,1.37s2.37-.6,2.37-1.35-1-1.37-2.36-1.37S157.3,349.62,157.3,350.37Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.83,350.38c0,.26.37.48.84.48s.84-.21.84-.48-.37-.48-.84-.48S158.83,350.11,158.83,350.38Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.83,350.38c0,.26.37.48.84.48s.84-.21.84-.48-.37-.48-.84-.48S158.83,350.11,158.83,350.38Z",
    style: {
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.63,339.34c-.68,2.67-.36,5.52-1.13,8.16-1.11,3.78-4.31,6.59-7.74,8.52-13.63,7.66-30.89,4-45.78,8.79-4.61,1.49-9.45,4.42-10.35,9.18-.65,3.42,1,7,3.56,9.35a24.16,24.16,0,0,0,9.14,4.86c13.27,4.38,27.59,3.93,41.41,1.8,14.67-2.27,28.5-10.65,33.64-14.56,8-6.05,13.84-15.85,12.43-25.75-1.29-9-9.71-15.66-17.93-18.7C415.37,328.58,406.4,332.43,404.63,339.34Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.56,152.57c3.56-2.25,10.37-4,16.16-2,10-3.45,15-2.82,23-2.83,1.79,0,7.62-.57,8.72.44.84.76,1.09,1.66,1.49,3.44l-3.56,9.48c-6.18,1.22-9.74,2.73-18.6,4.13-7,1.11-11.44,1.78-12.21,5.09A54.87,54.87,0,0,1,416.56,152.57Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469,157.59c1.18-1.47,1.21-3.27,1.08-5.63-.22-3.78-1.6-11-2.17-14.22-.9-5.21-1.92-8.35-2.66-12.51-.79-4.46-.32-6.8-1.92-10.33-1.46-3.22-11.24-4.18-13.26.11-1.16,2.47,3.08,3.71,3.2,5.59,0,0-3.87-1.21-3.06,1.17,1,2.86,4.65,2.69,5.09,6.35.63,5.15,0,13.73,0,21.54,0,3.22,1.62,12.68,1.62,12.68C460.87,161.22,466.36,160.88,469,157.59Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.77,125.23l1.49-4.72L451.09,118c1,.89,2.1,1.69,2.16,2.65,0,0-3.87-1.21-3.06,1.17a4,4,0,0,0,1.1,1.63,29.92,29.92,0,0,0,4,1.95c2.39.73,4.21.5,5.11-.9C460.44,124.41,462.77,125.23,462.77,125.23Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.28,147.63a11.07,11.07,0,0,1,7.37,3s-.5-3.71-7.36-4.92l0,1.84Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--dumbbell--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.52,112.71v0a5.54,5.54,0,0,0-9.29-2.47l0,0a1.14,1.14,0,0,0-.11.11l-.12.13a11.22,11.22,0,0,0-2.4,9.47V120c0,.17.1.33.15.48v0a5.54,5.54,0,0,0,6.62,3.44,6.29,6.29,0,0,0,1.14-.45,5.06,5.06,0,0,0,1.41-1,11.13,11.13,0,0,0,2.63-9.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.93,111.25A11.11,11.11,0,0,0,442.3,121c.83,3.1,3.34,3.78,5.61,1.52a11.13,11.13,0,0,0,2.63-9.72C449.71,109.66,447.2,109,444.93,111.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.5,119.58h-.05l-19-5.28h0a1.32,1.32,0,0,0-1.33.46,4.24,4.24,0,0,0-1,3.73,1.34,1.34,0,0,0,.89,1.07l19,5.28h0a1.35,1.35,0,0,0,1.31-.47,4.26,4.26,0,0,0,1-3.74A1.36,1.36,0,0,0,466.5,119.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.18,123.78a1.17,1.17,0,0,0,2.15.59,4.26,4.26,0,0,0,1-3.74c-.32-1.19-1.28-1.45-2.15-.58A4.24,4.24,0,0,0,464.18,123.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.79,116.42c-.87-2.55-.58-3.08-2.7-3.54s-2.13-2.22-4.24-2-3.7,1-4.64.67-2.82.74-3.69,2.15a8.61,8.61,0,0,0-.73,4.93c.12,1.43,1.63,3.13,4.54,4.32s7.14,3,8.06.57l-1.2-.33a4.14,4.14,0,0,1,1.64-5.21l1.48.41Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.08,118.92v0A5.54,5.54,0,0,0,466.3,115a5.46,5.46,0,0,0-2.51,1.46l0,0-.1.12-.13.13a11.17,11.17,0,0,0-2.39,9.47v.06c.05.16.1.32.16.48h0a5.54,5.54,0,0,0,6.62,3.44,5.74,5.74,0,0,0,1.14-.44,5.3,5.3,0,0,0,1.42-1A11.1,11.1,0,0,0,473.1,119,.14.14,0,0,0,473.08,118.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.49,117.46a11.13,11.13,0,0,0-2.62,9.72c.82,3.1,3.33,3.78,5.61,1.51A11.1,11.1,0,0,0,473.1,119C472.28,115.88,469.77,115.2,467.49,117.46Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M349.63,374.3c-.33.11-.38,2-.08,2.65s2.41,3,6.66,3.83,10.1,0,12.61-.15,10.41.81,12.92,1.15c3.94.53,7-.33,8.45-1.76a2.65,2.65,0,0,0,.59-2.08c-.07-1.67-.22-2-.42-2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.71,371q.12.5.21,1a17,17,0,0,1,.37,5.12,4.66,4.66,0,0,1-3,2.29c-3,.94-5.24.79-8.53.17a59.49,59.49,0,0,0-10-.62,62.42,62.42,0,0,1-8.74.44,21,21,0,0,1-6.44-1.32c-1.73-.74-3.49-1.68-3.91-3.46a5.85,5.85,0,0,1,3.25-5.85c3.17-1.86,7.22-1.89,10.79-2,2.87-.09,5.85-.16,8.4-1.48a37.19,37.19,0,0,1,3.93-2.24,10,10,0,0,1,3-.14c2.23-.05,4.46-.1,6.68-.12.61,0,1.22,0,1.82,0,1.2.1,1.42,4.25,1.56,5.05.12.64.14,1.31.31,1.93C389.5,370.18,389.61,370.59,389.71,371Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,366.1a7.37,7.37,0,0,0-2.67,4.6c.06,1.26-2.15,1.37-2.21.11,0,0,.2-2.85,1.93-4.21A4.8,4.8,0,0,1,370,366.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.88,366.73s-1.71.9-2.15,4c0,.93-2,.85-1.93-.08,0,0,.3-2.68,1.76-3.89C363.17,366.37,364.68,366.36,364.88,366.73Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.09,336.32c-.75,2.94-.66,4.21.21,6.51,1.24,3.31,3.44,4.83,4.92,6.12a24.79,24.79,0,0,1,4.36,5.07,21.71,21.71,0,0,0,4.55,5.46c1.41,1.17,5.31,1.2,7.18.37s2.48-1.55,2.31-4.55-9.31-3.85-9.31-3.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.2,346.43c.77.28,1,1.75,1.17,4.67.14,2.21,1.13,5.44-1.89,6.89-2.44,1.18-6.38.51-8.09-1.55-2.12-2.56-3.57-4.82-6.6-7.94-2.62-2.71-5.31-3.58-6.57-9.07-.8-3.53.72-5,3.08-6,3.25-1.46,7.76,2,10.11,3.62C425.31,338.31,431.42,346.16,432.2,346.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.41,336.89l-.44-.14a8.48,8.48,0,0,0-7,4.82c-.43,1,.95,1.71,1.74.94a9.07,9.07,0,0,1,7-4.8A3.81,3.81,0,0,0,423.41,336.89Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.58,338.53A8.43,8.43,0,0,0,419,343.3c-.42,1,.95,1.71,1.74.94a8.69,8.69,0,0,1,5.86-4.56C426.28,339.27,425.92,338.87,425.58,338.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.47,281.73c-.51-10.76.66-29.61.54-42.85,3.41-11.65,1-16.56-2-22.31a105.27,105.27,0,0,0-7.52-12.66l-7,29.49-11.23,11.94s6.69,34.69,8.34,42.17c1.4,6.36,9,59.41,9,59.41.71,3.46,8.76,3.9,10.67,1.45.54-11.77,2.69-45.25,2.72-49C435.1,288.38,431.47,281.73,431.47,281.73Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.62,228.86s-4.45,63.74-4.45,76.39c0,4.84-2.64,59.63-2.64,59.63,0,1.43,1.33,2.49,4.62,2.35,4.69-.21,7.35-1.08,7.54-2,.14-.65,7.33-30.71,9.19-40.53a74.46,74.46,0,0,0,.78-22.21c2.65-14.1,8-44.83,9.25-54.92C408,238.94,382.62,228.86,382.62,228.86Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.19,205.88c-2.27,13.73-2.68,18-4.35,35.6-1.3,13.7-2.1,53.3-2.16,58.83S376.57,340,376.57,340s10.33,3.89,16.9,1c0,0,2.91-11.9,4.17-17.3,1.77-7.58,1.73-12.92.87-21.45l7.5-46.6s6,33.48,7.78,43,3.51,18.77,3.51,18.77a23.32,23.32,0,0,0,8.77,1.39,14.3,14.3,0,0,0,8.32-3.09s.88-12.62.91-16.89c.05-6.81-.55-10.2-3.44-17.29l.95-42.69s3.11-7.59,1-15c-2.68-9.27-10.85-23.21-10.85-23.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,255.72l3-11.08s9.29-.74,14.23-7.15c-1.58,3-3.1,6.57-11.48,9.76l-2.93,11.31,4.34,36.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.57,165.34c-.63-4.47-2.22-9.89-6.52-11.75S413,152.46,413,152.46c-.61,2-8,4.65-11.7,1.13-3.56.75-7.93,1.56-12.72,2.73-3.8.92-6,15.31-8.53,20-2.94,5.45.8,11,4.54,13.9,0,0-.1,8.7-.39,15.71,6.56,5.5,18.81,7,28.28,4.53,7.13-1.86,9.93-4.08,10.52-6.85.47-2.16,1.73-9.16,2.77-12.93C428.17,181.94,432.41,171.29,431.57,165.34Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.05,153.59c-4.31-1.85-12.06-1.13-12.06-1.13-.61,2-8,4.65-11.7,1.13-3.56.75-7.93,1.56-12.72,2.73-3.8.92-7.94,10.1-10.06,19.48-1.36,6,2.09,11.32,5.82,14.18,0,0,.11,2.54.15,5.78,7.41,3.57,17.33,5.3,29.08,3.06a36.14,36.14,0,0,0,11.23-4.13c.24-.72.49-1.86,2.1-6.5s5.52-16.9,4.68-22.85C430.94,160.87,429.35,155.45,425.05,153.59Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.57,156.32c-5.77-.39-12.13,1.36-14.69,12.7-2,2.87-5.14,6.28-8,10.65-3.2,5-5,9.28-8,14.75-2.91,5.82-1.61,7.57,1.26,10.24,2.63,2.45,18.69,13,19.65,14.22s0,13.15,1.73,14.85c0,.07,0,.09,0,0,0-.37.33-1.91.77-3.83a35.94,35.94,0,0,1,4-8.64c1.44-2.42,2.76-5.17,2.34-8-.23-1.57-2.47-2.67-4-4.15-4.05-3.87-11.73-11.42-11.73-11.42l18.51-20.8C393.61,172.75,395.44,160.1,388.57,156.32Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.93,197.7a23.49,23.49,0,0,1-5.36,3.8,12.67,12.67,0,0,0,6.3-2.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.08,111.29v-.07a5.09,5.09,0,0,1,1.08-3.88,6.22,6.22,0,0,1,2.61-1.32c2.57-.81,5.14-1.62,7.74-2.33,4.9-1.34,10-2.33,15.06-1.69s10.06,3.1,12.76,7.41a6,6,0,0,1,1.06,2.47c.05.6-.19,1.14-.16,1.75.09,1.87,1,3.69,1.24,5.54a43.2,43.2,0,0,1,.29,6c0,8.3-19.51,12.85-19.38,18.54q-4.86-6.45-9.71-12.92c0-.52-1.37-1.88-1.67-2.33-.58-.85-1.09-1.76-1.62-2.64-1.64-2.75-4.41-4.2-6.32-6.68A14.31,14.31,0,0,1,386.08,111.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.79,125.78s-3.54,4.79-3.13,5.33a7.82,7.82,0,0,0,2.5,1.19Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.63,110.58c-3.3,1.5-9,4.29-11,15.92-2,11.94.53,16.23,2.13,17.88,1.08,1.11,6.86,1.75,9.93,1,3.83-1,12.21-4.62,16.32-10.64,4.85-7.1,6.21-16.77,1.15-20.81C412.09,108.21,403.43,109.31,400.63,110.58Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.12,144.69l-.15,9.63c3.26,4.3,15.3,3.57,14.7-1.71l.23-10.06Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.1,144.6c1.33.81,5.11,1.3,8,1l.07-2.17a21.65,21.65,0,0,1-3.88,1.08A13.51,13.51,0,0,1,392.1,144.6Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.23,110.16a12.87,12.87,0,0,0-3.85,2,5.17,5.17,0,0,0-1.41,1.65,3.89,3.89,0,0,0-.35,1.93,5.14,5.14,0,0,0,2.83,4.3,5.06,5.06,0,0,0-1,4.14,10.1,10.1,0,0,0,2.78,4.4.75.75,0,0,0,.24.19.66.66,0,0,0,.53-.14c2.09-1.27,3.45-3.55,6.28-2.49,3.7,1.4,3.75,5.06,1.38,8.2a5,5,0,0,1-3.62,2.29,2.79,2.79,0,0,1-2.31-.78s.31,7,5.48,9.61c0,0,5.3,1.89,8.69-.11,2.11-3.58,5.62-5.87,8-9,6.3-8.31,11.79-22.32-1.34-27.26-.45-.17-.91-.33-1.37-.47a28.5,28.5,0,0,0-19.42,1C400.26,109.78,399.74,110,399.23,110.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441,150.67h0a14.47,14.47,0,0,1-14.48-14.47V112.58h0A14.48,14.48,0,0,1,441,127.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.81,132.8a2.78,2.78,0,0,1-1.55-3.65,2.86,2.86,0,0,1,3.71-1.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.39,112.11a2.45,2.45,0,0,0,3.48-.34,2.52,2.52,0,0,0-.38-3.52Z",
    style: {
      fill: "#263238"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.74,111.19l-4.24-8,3.41-9.86v-6l-10.45,6v6l4.49,7.78a.61.61,0,0,0,.31.27h0Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.74,111.19l-4.24-8,3.41-9.86v-6l-10.45,6v6l4.49,7.78a.61.61,0,0,0,.31.27h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.79,63.63a6.91,6.91,0,0,0-3.13-5.42l-2.55-1.48a7,7,0,0,0-6.27,0l-74.15,43a6.93,6.93,0,0,0-3.13,5.43v21.5a6.92,6.92,0,0,0,3.13,5.42l2.55,1.47a6.93,6.93,0,0,0,6.27,0L125,103.19l4.49,7.77a.67.67,0,0,0,1.21-.12l4.74-13.67,11.2-6.61a6.93,6.93,0,0,0,3.13-5.43Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.56,126.63a6.92,6.92,0,0,0,3.13,5.42l2.55,1.47a7,7,0,0,0,5.73.26c-1.47.55-2.59-.28-2.59-2.07V110.22a6.47,6.47,0,0,1,.91-3.09L61.48,102a6.37,6.37,0,0,0-.92,3.09Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.69,62.74c-.37-1.33-1.58-1.75-3-.92l-74.15,43a6.25,6.25,0,0,0-2.21,2.34l-8.81-5.08a6.23,6.23,0,0,1,2.2-2.34l74.15-43a6.93,6.93,0,0,1,6.27,0l2.55,1.47A6.92,6.92,0,0,1,149.69,62.74Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73,115.4a.6.6,0,0,1-.08-.42,1.34,1.34,0,0,1,.17-.51l3.22-5.66c.08-.14.17-.31.29-.49a1.16,1.16,0,0,1,.4-.42l1.82-1.05a.21.21,0,0,1,.29,0,.48.48,0,0,1,.12.37v14.89a1.19,1.19,0,0,1-.12.51.72.72,0,0,1-.29.34l-2,1.14a.22.22,0,0,1-.28,0,.5.5,0,0,1-.12-.37V113.65l-1.79,3.11a.6.6,0,0,1-.29.3.21.21,0,0,1-.27-.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.07,118.3a2.57,2.57,0,0,1,.19-.72,1.06,1.06,0,0,1,.46-.55L83.56,116a.18.18,0,0,1,.23,0,.38.38,0,0,1,.1.3.88.88,0,0,1,0,.17l-1.16,5.26a3.1,3.1,0,0,1-.21.6,1,1,0,0,1-.44.51l-1.12.65a.17.17,0,0,1-.23,0,.38.38,0,0,1-.1-.3v0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.55,103.51a10.05,10.05,0,0,1-.09,1.34,9.18,9.18,0,0,1-.31,1.39,10.73,10.73,0,0,1-.57,1.49,16.51,16.51,0,0,1-.86,1.65L89.62,113l3.76-2.17a.21.21,0,0,1,.29,0,.48.48,0,0,1,.12.37v2.44a1.19,1.19,0,0,1-.12.51.8.8,0,0,1-.29.35l-7.9,4.56a.22.22,0,0,1-.29,0,.5.5,0,0,1-.12-.37v-2a3.23,3.23,0,0,1,.1-.79,2.55,2.55,0,0,1,.34-.82L90,107.62a5.68,5.68,0,0,0,.66-1.48,4.52,4.52,0,0,0,.14-1c0-.11,0-.25,0-.43a1.31,1.31,0,0,0-.17-.48.62.62,0,0,0-.38-.27,1,1,0,0,0-.67.18,2,2,0,0,0-.68.61,3.61,3.61,0,0,0-.41.73,5.74,5.74,0,0,0-.21.68l-.09.49a1.26,1.26,0,0,1-.24.56,1.19,1.19,0,0,1-.36.31l-1.85,1.07a.18.18,0,0,1-.23,0,.41.41,0,0,1-.09-.3,10,10,0,0,1,.27-2.08A10.21,10.21,0,0,1,86.4,104a9.64,9.64,0,0,1,1.28-2,6.68,6.68,0,0,1,1.82-1.53,3.48,3.48,0,0,1,1.75-.56,1.85,1.85,0,0,1,1.26.47,2.85,2.85,0,0,1,.78,1.28A6.4,6.4,0,0,1,93.55,103.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.34,110.06a2.57,2.57,0,0,1,.19-.72,1.11,1.11,0,0,1,.46-.55l1.84-1.07a.18.18,0,0,1,.23,0,.38.38,0,0,1,.1.3.88.88,0,0,1,0,.17L97,113.47a3.1,3.1,0,0,1-.21.6,1,1,0,0,1-.44.51l-1.12.65a.17.17,0,0,1-.23,0,.38.38,0,0,1-.1-.3v0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.28,90.4a.2.2,0,0,1,.28,0,.47.47,0,0,1,.12.36v2.45a1.41,1.41,0,0,1-.1.52c-.07.18-.14.33-.2.46l-1.81,3.86a2.1,2.1,0,0,1,1.9.45,3.3,3.3,0,0,1,.74,2.47,8.63,8.63,0,0,1-4.44,7.8,5.11,5.11,0,0,1-1.9.71,2.35,2.35,0,0,1-1.41-.23,2.09,2.09,0,0,1-.87-1,3.48,3.48,0,0,1-.32-1.49,1,1,0,0,1,.09-.41.62.62,0,0,1,.24-.28l1.88-1.09q.31-.18.48-.06l.37.26a1.1,1.1,0,0,0,.52.17,1.72,1.72,0,0,0,.92-.31A4,4,0,0,0,105,104a2.4,2.4,0,0,0,.47-1.45c0-.53-.16-.84-.47-.9a1.81,1.81,0,0,0-1.2.32l-1.24.72a.22.22,0,0,1-.28,0,.5.5,0,0,1-.12-.37v-2a1.45,1.45,0,0,1,.1-.52c.07-.18.14-.34.21-.49L104,96l-3.91,2.26a.22.22,0,0,1-.28,0,.5.5,0,0,1-.12-.37V95.38a1.15,1.15,0,0,1,.12-.5.74.74,0,0,1,.28-.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.4,103a1.19,1.19,0,0,1-.12.51.75.75,0,0,1-.29.35l-2,1.13a.2.2,0,0,1-.28,0,.48.48,0,0,1-.12-.37v-3a1.15,1.15,0,0,1,.12-.5.74.74,0,0,1,.28-.35l2-1.13a.22.22,0,0,1,.29,0,.5.5,0,0,1,.12.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.7,100.47a1.19,1.19,0,0,1-.12.51.75.75,0,0,1-.29.35l-2,1.13a.21.21,0,0,1-.28,0,.5.5,0,0,1-.12-.37v-3a1.19,1.19,0,0,1,.12-.51.75.75,0,0,1,.28-.34l2-1.14a.24.24,0,0,1,.29,0,.5.5,0,0,1,.12.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,98a1.19,1.19,0,0,1-.12.51.79.79,0,0,1-.28.35l-2,1.13a.22.22,0,0,1-.29,0,.5.5,0,0,1-.12-.37v-3a1.19,1.19,0,0,1,.12-.51.77.77,0,0,1,.29-.34l2-1.14a.22.22,0,0,1,.28,0A.5.5,0,0,1,121,95Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.94,82.5a3.36,3.36,0,0,0-.86.71,4.12,4.12,0,0,0-.56.92,5,5,0,0,0-.32,1,10,10,0,0,0-.15,1.1c0,.21,0,.49,0,.85v1.1c0,.37,0,.74,0,1.1s0,.63,0,.82a5.05,5.05,0,0,0,.14.93,1.7,1.7,0,0,0,.33.66.77.77,0,0,0,.57.26,1.54,1.54,0,0,0,.85-.27,3.47,3.47,0,0,0,.73-.56,3.37,3.37,0,0,0,.6-.78,4.25,4.25,0,0,0,.4-1,5,5,0,0,0,.15-1.26l-1.25.73a.24.24,0,0,1-.29,0,.5.5,0,0,1-.12-.37V86a1.11,1.11,0,0,1,.12-.5.75.75,0,0,1,.29-.35l3.62-2.1a.21.21,0,0,1,.28,0,.46.46,0,0,1,.12.36v2.95a11.26,11.26,0,0,1-.36,2.86,11.13,11.13,0,0,1-1,2.57,10.08,10.08,0,0,1-1.48,2.11,7.73,7.73,0,0,1-1.83,1.49A3.9,3.9,0,0,1,125,96a2.21,2.21,0,0,1-1.44-.52,3.09,3.09,0,0,1-.92-1.46,7.6,7.6,0,0,1-.37-2.2q0-.91,0-2c0-.72,0-1.42,0-2.09a12,12,0,0,1,.36-2.62,12.62,12.62,0,0,1,.92-2.52A10.16,10.16,0,0,1,125,80.42a7.77,7.77,0,0,1,1.93-1.61,4,4,0,0,1,1.88-.61,2.52,2.52,0,0,1,1.43.37,2.65,2.65,0,0,1,.91,1.07,3.56,3.56,0,0,1,.36,1.44.79.79,0,0,1-.09.41.72.72,0,0,1-.24.29l-2,1.15c-.15.08-.27.08-.35,0l-.25-.27a1.18,1.18,0,0,0-.57-.43A1.42,1.42,0,0,0,126.94,82.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.92,80.24c0,.22,0,.52,0,.88s0,.66,0,.89a10,10,0,0,1-.33,2.27,10.9,10.9,0,0,1-.82,2.17,9.29,9.29,0,0,1-1.26,1.87,6.7,6.7,0,0,1-1.66,1.37,3.54,3.54,0,0,1-1.65.54,1.9,1.9,0,0,1-1.27-.41,2.77,2.77,0,0,1-.82-1.22,5.8,5.8,0,0,1-.33-1.88c0-.23,0-.52,0-.88s0-.66,0-.9a9.38,9.38,0,0,1,.31-2.26,10.93,10.93,0,0,1,.83-2.17,9.51,9.51,0,0,1,1.28-1.89,6.32,6.32,0,0,1,1.65-1.38,3.4,3.4,0,0,1,1.66-.53,2,2,0,0,1,1.27.42,2.69,2.69,0,0,1,.82,1.22A5.82,5.82,0,0,1,140.92,80.24ZM135.47,85a1.52,1.52,0,0,0,.41,1.14.83.83,0,0,0,1-.06,2.51,2.51,0,0,0,1-1.06,3.9,3.9,0,0,0,.41-1.61c0-.24,0-.51,0-.8s0-.55,0-.76a1.52,1.52,0,0,0-.41-1.14.83.83,0,0,0-1,.06,2.57,2.57,0,0,0-1,1.06,4,4,0,0,0-.41,1.61c0,.24,0,.51,0,.8S135.45,84.83,135.47,85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.07,79.13a1.19,1.19,0,0,1-.12.51.74.74,0,0,1-.28.35l-1.89,1.09a.21.21,0,0,1-.28,0,.5.5,0,0,1-.12-.37V70.75a1.15,1.15,0,0,1,.12-.5.74.74,0,0,1,.28-.35l1.89-1.09a.21.21,0,0,1,.28,0,.5.5,0,0,1,.12.37Zm0,5a1.19,1.19,0,0,1-.12.51.79.79,0,0,1-.28.35L142.78,86a.22.22,0,0,1-.28,0,.5.5,0,0,1-.12-.37V83.32a1.19,1.19,0,0,1,.12-.51.79.79,0,0,1,.28-.35l1.89-1.09a.22.22,0,0,1,.28,0,.5.5,0,0,1,.12.37Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.43,87.46l-4.25-8,3.42-9.86v-6l-10.45,6v6l4.49,7.78a.67.67,0,0,0,.31.27h0Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.43,87.46l-4.25-8,3.42-9.86v-6l-10.45,6v6l4.49,7.78a.67.67,0,0,0,.31.27h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.49,35.94a6.93,6.93,0,0,0-3.13-5.43L429.81,29a6.93,6.93,0,0,0-6.27,0L370.65,59.48a6.94,6.94,0,0,0-3.14,5.42V86.4a6.94,6.94,0,0,0,3.14,5.43l2.55,1.47a6.91,6.91,0,0,0,6.26,0l24.25-13.84,4.48,7.77a.67.67,0,0,0,1.21-.12l4.74-13.67,18.22-10.57a6.93,6.93,0,0,0,3.13-5.43Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.51,86.4a6.94,6.94,0,0,0,3.14,5.43l2.55,1.47a7,7,0,0,0,5.73.25c-1.48.56-2.6-.27-2.6-2.06V70a6.34,6.34,0,0,1,.92-3.08l-8.82-5.09a6.45,6.45,0,0,0-.92,3.08Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.39,35.05c-.37-1.33-1.58-1.75-3-.92l-52.9,30.44a6.32,6.32,0,0,0-2.21,2.34l-8.81-5.09a6.4,6.4,0,0,1,2.21-2.34L423.54,29a7,7,0,0,1,6.27,0l2.55,1.48A6.92,6.92,0,0,1,435.39,35.05Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M380.42,75a.56.56,0,0,1-.08-.41,1.34,1.34,0,0,1,.17-.51l3.22-5.67c.08-.13.17-.3.29-.49a1.13,1.13,0,0,1,.4-.41l1.82-1a.21.21,0,0,1,.29,0,.47.47,0,0,1,.12.36v14.9a1.11,1.11,0,0,1-.12.5.75.75,0,0,1-.29.35l-2,1.14a.22.22,0,0,1-.28,0,.5.5,0,0,1-.12-.37V73.25l-1.79,3.11a.7.7,0,0,1-.29.3.21.21,0,0,1-.27-.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.53,77.89a2.6,2.6,0,0,1,.19-.71,1.13,1.13,0,0,1,.46-.56L391,75.56a.17.17,0,0,1,.23,0,.38.38,0,0,1,.1.3.88.88,0,0,1,0,.17l-1.16,5.26a3.1,3.1,0,0,1-.21.6,1,1,0,0,1-.44.51l-1.12.65a.18.18,0,0,1-.23,0,.38.38,0,0,1-.1-.3v0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,63.11a10.17,10.17,0,0,1-.09,1.34,9.46,9.46,0,0,1-.31,1.39,11.23,11.23,0,0,1-.57,1.49,16.51,16.51,0,0,1-.86,1.65l-2.1,3.66,3.76-2.17a.21.21,0,0,1,.29,0,.47.47,0,0,1,.12.36V73.3a1.19,1.19,0,0,1-.12.51.77.77,0,0,1-.29.34l-7.9,4.57a.22.22,0,0,1-.29,0,.5.5,0,0,1-.12-.37v-2a3.36,3.36,0,0,1,.1-.8,2.59,2.59,0,0,1,.34-.81l4.47-7.52a5.68,5.68,0,0,0,.66-1.48,4.59,4.59,0,0,0,.14-1c0-.11,0-.25,0-.43a1.25,1.25,0,0,0-.17-.48.62.62,0,0,0-.38-.27.91.91,0,0,0-.67.17,2.14,2.14,0,0,0-.68.62,3.36,3.36,0,0,0-.41.73,5.22,5.22,0,0,0-.21.68l-.09.48a1.26,1.26,0,0,1-.24.57,1.34,1.34,0,0,1-.36.31l-1.85,1.06a.17.17,0,0,1-.23,0,.41.41,0,0,1-.09-.3,9.9,9.9,0,0,1,.27-2.08,10.21,10.21,0,0,1,.77-2.19,9.64,9.64,0,0,1,1.28-2A6.9,6.9,0,0,1,397,60a3.45,3.45,0,0,1,1.75-.55,1.85,1.85,0,0,1,1.26.47,2.85,2.85,0,0,1,.78,1.28A6.4,6.4,0,0,1,401,63.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.8,69.66a2.57,2.57,0,0,1,.19-.72,1.13,1.13,0,0,1,.46-.56l1.84-1.06a.17.17,0,0,1,.23,0,.38.38,0,0,1,.1.3.88.88,0,0,1,0,.17l-1.16,5.26a3.1,3.1,0,0,1-.21.6,1,1,0,0,1-.44.51l-1.12.65a.18.18,0,0,1-.23,0,.38.38,0,0,1-.1-.3v0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.74,50a.22.22,0,0,1,.28,0,.5.5,0,0,1,.12.37v2.45a1.41,1.41,0,0,1-.1.52c-.07.18-.14.33-.2.46L413,57.66a2.13,2.13,0,0,1,1.9.46,3.28,3.28,0,0,1,.74,2.47,8.91,8.91,0,0,1-1.17,4.6,8.79,8.79,0,0,1-3.27,3.19,5,5,0,0,1-1.9.72,2.42,2.42,0,0,1-1.41-.23,2.09,2.09,0,0,1-.87-1,3.48,3.48,0,0,1-.32-1.49,1,1,0,0,1,.09-.41.72.72,0,0,1,.24-.29l1.88-1.08c.21-.13.37-.14.48-.06l.37.26a1.1,1.1,0,0,0,.52.17,1.72,1.72,0,0,0,.92-.31,3.8,3.8,0,0,0,1.19-1.06,2.36,2.36,0,0,0,.48-1.45q0-.81-.48-.9a1.74,1.74,0,0,0-1.19.32l-1.24.71a.2.2,0,0,1-.28,0,.47.47,0,0,1-.12-.36V60a1.41,1.41,0,0,1,.1-.52c.07-.18.14-.34.21-.49l1.59-3.38-3.91,2.25a.2.2,0,0,1-.28,0,.47.47,0,0,1-.12-.36V55a1.19,1.19,0,0,1,.12-.51.75.75,0,0,1,.28-.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.86,62.55a1.19,1.19,0,0,1-.12.51.8.8,0,0,1-.29.35l-2,1.13a.21.21,0,0,1-.28,0,.5.5,0,0,1-.12-.37v-3a1.19,1.19,0,0,1,.12-.51.75.75,0,0,1,.28-.34l2-1.14a.24.24,0,0,1,.29,0,.5.5,0,0,1,.12.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.16,60.07a1.19,1.19,0,0,1-.12.51.8.8,0,0,1-.29.35l-2,1.13a.21.21,0,0,1-.28,0,.5.5,0,0,1-.12-.37v-3a1.19,1.19,0,0,1,.12-.51.79.79,0,0,1,.28-.35l2-1.13a.24.24,0,0,1,.29,0,.5.5,0,0,1,.12.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.45,57.59a1.19,1.19,0,0,1-.12.51.79.79,0,0,1-.28.35l-2,1.13a.22.22,0,0,1-.29,0,.5.5,0,0,1-.12-.37v-3a1.19,1.19,0,0,1,.12-.51.8.8,0,0,1,.29-.35l2-1.13a.22.22,0,0,1,.28,0,.5.5,0,0,1,.12.37Z",
    style: {
      fill: "#fafafa"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOt);
export default __webpack_public_path__ + "static/media/OT.35676a39d866177651f7dd9680e037d1.svg";
export { ForwardRef as ReactComponent };